<template>
  <div>
    <sui-page-tab-headless
      v-show="!isMain"
      :tabItems="tabItems"
      :defaultTabIndex="defaultTabIndex"
      :setCurrentTabComponent="setCurrentTabComponent"
    >
      <container
        :is="currentTabComponent"
        ref="regTab"
        @onChangeMain="onChangeMain"
        @page-deactivate="handleChildDeactivated" 
        @page-activate="handleChildActivated"
      />
    </sui-page-tab-headless>

    <sui-page v-show="isMain">
      <sui-page-header :pageId="this.$options.name" />
      <sui-page-contents>
        <div class="comm_scr_wrap">
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_SITE_ID')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model.trim="searchBox.siteId"
                maxlength="50"
                :disabled="false"
                :readonly="false"
                @keyup.enter="onSearch"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_SITE_ABBR')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model.trim="searchBox.siteAbbreviationName"
                maxlength="50"
                :disabled="false"
                :readonly="false"
                @keyup.enter="onSearch"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_GNRZ_AREA')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-code-select
                :selected="searchBox.generalizationAreaCode"
                :codeId="'COD_GNRZ_AREA'"
                :defaultOption="'all'"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_LANG')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-lang-select
                :selected="searchBox.langId"
                :pageId="this.$options.name"
                :defaultOption="'all'"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_BIZ_SECT')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-code-select
                :selected="searchBox.businessSectorDivisionCode"
                codeId="COD_BIZ_SECT_DIV"
                :defaultOption="'all'"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_USE_YN')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-yn-select
                :selected="searchBox.siteInfoUseYn"
                :defaultOption="'all'"
                :initialSelectedIndex="0"
              />
            </div>
          </div>
          <div class="btn_wrap">
            <sui-button
              type="button"
              class="comm_btn_Reset"
              @click="onReset"
            >
              {{ $t("MSG_BTN_RESET") }}
            </sui-button>
            <sui-button
              type="button"
              class="comm_btn_Scr"
              @click="onSearch"
            >
              {{ $t("MSG_BTN_SEARCH") }}
            </sui-button>
          </div>
        </div>
        <div class="mrB30" />
        <sui-grid
          ref="grid"
          :columns="gridColumns0"
          :dataset="'dsSite'"
          :initialPagesize="10"
          :showDisplayCountControl="false"
        >
          <div class="btn_wrapR">
            <sui-button
              v-permission:download="this.$options.name"
              type="button"
              class="comm_btn_gridTop comm_ico_excel"
              @click="onDownloadExcel"
            >
              {{ $t("MSG_BTN_EXCEL_DOWN") }}
            </sui-button>
          </div>
        </sui-grid>
        <div class="comm_btn_wrap">
          <sui-button
            v-permission:create="this.$options.name"
            type="button"
            class="comm_btn_solid"
            @click="onCreate"
          >
            {{ $t("MSG_BTN_RGST") }}
          </sui-button>
        </div>
      </sui-page-contents>
    </sui-page>
  </div>
</template>
<script>
import BasePage from '~cm/components/BasePage';

const PGE_CMY_00017 = utils.getPageComponentById('PGE_CMY_00017');

export default {
  name: 'PGE_CMY_00015', // eslint-disable-line vue/name-property-casing
  components: {
    PGE_CMY_00017,
  }, // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  data() {
    return {
      isMain: true,
      defaultTabIndex: 0,
      tabItems: [
        {
          tabTitle: 'tab01',
          tabSubTitle: 'sub01',
          component: 'PGE_CMY_00017',
        },
      ],
      currentTabComponent: null,
      tabIndex: 0,

      // Search Box
      searchBox: {
        siteId: '',
        siteAbbreviationName: '',
        generalizationAreaCode: { key: '', label: '' },
        langId: { key: '', label: '' },
        businessSectorDivisionCode: { key: '', label: '' },
        siteInfoUseYn: { key: '', label: '' },
      },
      localdata0: [
        // siteAbbreviationName:[{ key: item.siteAbbreviationName, label: item.siteAbbreviationName , type: 'sublink'}]
      ],
      gridColumns0: [{
        text: this.$t('MSG_TXT_SITE_ID'),
        datafield: 'siteId',
        width: 150,
      }, {
        text: this.$t('MSG_TXT_SITE_ABBR'),
        datafield: 'siteAbbreviationName',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButtonList(row, column, value, htmlElement, {
            handler: this.onGridButtonClicked,
          }, this.dsSite, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_GNRZ_AREA'),
        datafield: 'generalizationAreaName',
        width: 150,
      }, {
        text: this.$t('MSG_TXT_LANG'),
        datafield: 'langName',
        width: 200,
      }, {
        text: this.$t('MSG_TXT_BIZ_SECT'),
        datafield: 'businessSectorDivisionName',
        width: 200,
      }, {
        text: this.$t('MSG_TXT_CURC'),
        datafield: 'currencyName',
        width: 200,
      }, {
        text: this.$t('MSG_TXT_ARRAY_ORDER'),
        datafield: 'arrayalOrder',
        width: 80,
      }, {
        text: this.$t('MSG_TXT_USE_YN'),
        datafield: 'siteInfoUseYn',
        width: 80,
      }, {
        text: this.$t('MSG_TXT_MDFC_USR'),
        datafield: 'finalModificationUserId',
        width: 200,
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1', // "1", "2" - default: "1"
            datafieldMap: {
              displayLanguageId: 'modificationDisplayLanguageId',
              knoxId: 'modificationKnoxId',
              userName: 'modificationUserName',
              userGlobalName: 'modificationUserGlobalName',
              departmentName: 'modificationDepartmentName',
              departmentEnglishName: 'modificationDepartmentEnglishName',
            },
            type: 'link', // 'link', 'sublink' - default: "link"
          }, this.dsSite, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_MDFC_DTM'),
        datafield: 'finalModificationDTM',
        width: '150px',
        createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, this.dsSite, this.$refs.grid),
        initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),        
      }],

      // excel
      localdata1: [],

      excelGridColumns: [{
        text: this.$t('MSG_TXT_SITE_ID'),
        datafield: 'siteId',
      }, {
        text: this.$t('MSG_TXT_SITE_ABBR'),
        datafield: 'siteAbbreviationName',
      }, {
        text: this.$t('MSG_TXT_GNRZ_AREA'),
        datafield: 'generalizationAreaName',
      }, {
        text: this.$t('MSG_TXT_LANG'),
        datafield: 'langName',
      }, {
        text: this.$t('MSG_TXT_BIZ_SECT'),
        datafield: 'businessSectorDivisionName',
      }, {
        text: this.$t('MSG_TXT_CURC'),
        datafield: 'currencyName',
      }, {
        text: this.$t('MSG_TXT_ARRAY_ORDER'),
        datafield: 'arrayalOrder',
      }, {
        text: this.$t('MSG_TXT_USE_YN'),
        datafield: 'siteInfoUseYn',
      }, {
        text: this.$t('MSG_TXT_MDFC_USR_ID'),
        datafield: 'modificationKnoxId',
      }, {
        text: this.$t('MSG_TXT_MDFC_USR'),
        datafield: 'modificationUserName',
      }, {
        text: this.$t('MSG_TXT_MDFC_DTM'),
        datafield: 'finalModificationDTM',
      }],
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dsSite',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'siteId', map: 'siteId' },
      { type: 'string', name: 'siteName', map: 'siteName' },
      { type: 'string', name: 'siteAbbreviationName', map: 'siteAbbreviationName' },
      { type: 'string', name: 'siteEnglishAbbreviationName', map: 'siteEnglishAbbreviationName' },
      { type: 'string', name: 'generalizationAreaCode', map: 'generalizationAreaCode' },
      { type: 'string', name: 'generalizationAreaName', map: 'generalizationAreaName' },
      { type: 'string', name: 'businessSectorDivisionCode', map: 'businessSectorDivisionCode' },
      { type: 'string', name: 'businessSectorDivisionName', map: 'businessSectorDivisionName' },
      { type: 'string', name: 'nationCode', map: 'nationCode' },
      { type: 'string', name: 'langId', map: 'langId' },
      { type: 'string', name: 'langName', map: 'langName' },
      { type: 'string', name: 'currencyCode', map: 'currencyCode' },
      { type: 'string', name: 'currencyName', map: 'currencyName' },
      { type: 'string', name: 'arrayalOrder', map: 'arrayalOrder' },
      { type: 'string', name: 'siteInfoUseYn', map: 'siteInfoUseYn' },
      { type: 'string', name: 'finalModificationDTM', map: 'finalModificationDTM' },
      { type: 'string', name: 'finalModificationUserId', map: 'finalModificationUserId' },

      { type: 'string', name: 'modificationDisplayLanguageId', map: 'modificationDisplayLanguageId' },
      { type: 'string', name: 'modificationKnoxId', map: 'modificationKnoxId' },
      { type: 'string', name: 'modificationUserName', map: 'modificationUserName' },
      { type: 'string', name: 'modificationUserGlobalName', map: 'modificationUserGlobalName' },
      { type: 'string', name: 'modificationDepartmentName', map: 'modificationDepartmentName' },
      { type: 'string', name: 'modificationDepartmentEnglishName', map: 'modificationDepartmentEnglishName' },

    ],
  }, {
    id: 'dsExcel',
    type: 'local',
    data: 'localdata1',
    datafields: [
      { type: 'string', name: 'siteId', map: 'siteId' },
      { type: 'string', name: 'siteName', map: 'siteName' },
      { type: 'string', name: 'siteAbbreviationName', map: 'siteAbbreviationName' },
      { type: 'string', name: 'siteEnglishAbbreviationName', map: 'siteEnglishAbbreviationName' },
      { type: 'string', name: 'generalizationAreaCode', map: 'generalizationAreaCode' },
      { type: 'string', name: 'generalizationAreaName', map: 'generalizationAreaName' },
      { type: 'string', name: 'businessSectorDivisionCode', map: 'businessSectorDivisionCode' },
      { type: 'string', name: 'businessSectorDivisionName', map: 'businessSectorDivisionName' },
      { type: 'string', name: 'nationCode', map: 'nationCode' },
      { type: 'string', name: 'langId', map: 'langId' },
      { type: 'string', name: 'langName', map: 'langName' },
      { type: 'string', name: 'currencyCode', map: 'currencyCode' },
      { type: 'string', name: 'currencyName', map: 'currencyName' },
      { type: 'string', name: 'arrayalOrder', map: 'arrayalOrder' },
      { type: 'string', name: 'siteInfoUseYn', map: 'siteInfoUseYn' },
      { type: 'string', name: 'finalModificationDTM', map: 'finalModificationDTM' },
      { type: 'string', name: 'finalModificationUserId', map: 'finalModificationUserId' },
    ],
  }],
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    setCurrentTabComponent(component) {
      this.currentTabComponent = component;
    },
    onChangeMain(sSearchYn) {
      if (sSearchYn === 'Y') {
        this.dsSite.setRawData([]);
        this.searchSite(true);
      } else {
         this.isMain = true;
      }
    },
    /** ***************************************************************************
        이벤트 영역
      ***************************************************************************** */
    onReset() {
      this.resetSearchBox();
    },
    onSearch() {
      this.searchSite();
    },
    // 그리드 사업장명 클릭
    onGridButtonClicked(btn, dataRow) {
      this.createSitePageMove(dataRow.siteId);
    },
    onDownloadExcel() {
      const sPageId = this.$options.name;
      const objGridColumns = this.excelGridColumns;
      const objGridDataset = this.dsExcel;

      const sToday = utils.now('YYYYMMDDHHmmss');
      const sExcelName = `siteMgt_${sToday}.xlsx`;

      utils.downloadGridToExcel(sPageId, objGridColumns, objGridDataset, sExcelName);
    },
    onCreate() {
      this.createSitePageMove();
    },
    /** ***************************************************************************
        함수 영역
      ***************************************************************************** */
    // 초기화
    resetSearchBox() {
      const has = Object.prototype.hasOwnProperty;
      utils.forEach(this.searchBox, (values, key) => {
        if (has.call(this.searchBox[key], 'key')) {
          this.searchBox[key] = { key: '', label: '' };
        } else {
          this.searchBox[key] = '';
        }
      });

      this.searchBox.generalizationAreaCode.key = 'ALL';
      this.searchBox.langId.key = 'ALL';
      this.searchBox.businessSectorDivisionCode.key = 'ALL';
      this.searchBox.siteInfoUseYn.key = 'ALL';
    },
    // 사업장목록 조회
    searchSite(isMain) {
      // searchBox -> paramsObj변환 { key : value, key : value }
      const queryParams = utils.reduce(this.searchBox, (result, value, key) => {
        const objResult = utils.clone(result);
        objResult[key] = utils.isUndefined(value.key) ? utils.trim(value) : utils.trim(value.key);
        return objResult;
      }, {});

      http.request(this.$options.name, 'DTS_CMY_00012', {
        query: queryParams,
      }).then(res => {
        
        // excel
        const dsExcel = utils.cloneDeep(res.data);
        dsExcel.firstRegistrationDTM = utils.dateformatToClient(dsExcel.firstRegistrationDTM);
        this.dsExcel.setRawData(dsExcel);

        // main
        utils.forEach(res.data, item => {
          const objItem = item;
          objItem.siteAbbreviationName = [
            { key: item.siteAbbreviationName, label: item.siteAbbreviationName, type: 'sublink' },
          ];
        });

        this.dsSite.setRawData(res.data);

        if ( isMain ) {
          this.isMain = true;
        }
        
      }).catch(error => {
        console.log(error);
      });
    },
    // 신규 사업장 등록 페이지 이동
    createSitePageMove(sSiteId) {
      // utils.goPage('PGE_CMY_00017', { siteId: sSiteId , searchBox: this.searchBox});
      this.isMain = false;

      if (utils.isEmpty(sSiteId)) {
        this.$refs.regTab.init();
      } else {
        this.$refs.regTab.init(sSiteId);
      }

      // utils.openLayerPopup('PGE_CMY_00017', this.onPagePopupClose, {
      //   pageInitialData: {},
      //   size: 'xl',
      // });
    },
    onPagePopupClose() {

    },
  },
};
</script>
<style scoped>
</style>
